// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { Component } from './component';
import { SmallButton } from './small-button';

/**
 * @class Jsw.DynamicSubForm
 * @extends Jsw.Component
 */
export const DynamicSubForm = Class.create(Component, {
    _initConfiguration($super, config) {
        $super(config);
        const getDynamicContent = this._getConfigParam('getDynamicContent', null);
        if (getDynamicContent) {
            this._getDynamicContent = getDynamicContent.bind(this);
        }
        const prepareDynamicContent = this._getConfigParam('prepareDynamicContent', null);
        if (prepareDynamicContent) {
            this._prepareDynamicContent = prepareDynamicContent.bind(this);
        }
        const bindDynamicContent = this._getConfigParam('bindDynamicContent', null);
        if (bindDynamicContent) {
            this._bindDynamicContent = bindDynamicContent.bind(this);
        }
        const insertDynamicContent = this._getConfigParam('insertDynamicContent', null);
        if (insertDynamicContent) {
            this._insertDynamicContent = insertDynamicContent.bind(this);
        }
        const onUpdateDynamic = this._getConfigParam('onUpdateDynamic', null);
        if (onUpdateDynamic) {
            this._onUpdateDynamic = onUpdateDynamic.bind(this);
        }
        const onInitDynamic = this._getConfigParam('onInitDynamic', null);
        if (onInitDynamic) {
            this._onInitDynamic = onInitDynamic.bind(this);
        }
    },

    _addEvents($super) {
        $super();
        const dynamicElements = this._componentElement.select('.dynamicSubFormContent');
        if (!dynamicElements.length) {
            this._addEmptyContent();
        } else {
            dynamicElements.each(function (element, index) {
                this._bindDynamicContent(element, !index);
            }, this);
        }
        this._onInitDynamic();
        this._onUpdateDynamic();
    },

    _addEmptyContent() {
        const element = this._prepareDynamicContent(this._getDynamicContent());
        this._insertDynamicContent(element);
        this._bindDynamicContent(element, true);
    },

    _getDynamicContent() {
        const dynamicElement = this._componentElement.down('.dynamicSubFormTemplate').cloneNode(true);
        dynamicElement.removeClassName('dynamicSubFormTemplate').addClassName('dynamicSubFormContent').show();
        return dynamicElement;
    },

    _prepareDynamicContent(content, value) {
        return content;
    },

    _insertDynamicContent(content) {
        const dynamicElements = this._componentElement.select('.dynamicSubFormContent');
        if (!dynamicElements.length) {
            this._componentElement.insert({ top: content });
        } else {
            dynamicElements.last().insert({ after: content });
        }
    },

    _bindDynamicContent(content, isFirstElement) {
    },

    _onInitDynamic() {
    },

    _onUpdateDynamic() {
    },

    deleteContent(content) {
        content.remove();
        this._onUpdateDynamic();
    },

    addContent(value) {
        const content = this._prepareDynamicContent(this._getDynamicContent(), value);
        this._insertDynamicContent(content);
        this._bindDynamicContent(content, false);
        this._onUpdateDynamic();
    },
});

/**
 * @class Jsw.AddRemoveDynamicSubForm
 * @extends Jsw.DynamicSubForm
 */
export const AddRemoveDynamicSubForm = Class.create(DynamicSubForm, {
    _initConfiguration($super, config) {
        $super(config);
        this._addButtonId = this._getConfigParam('addButtonId', '');
        this._addButtonTitle = this._getConfigParam('addButtonTitle', '');
        this._removeButtonId = this._getConfigParam('removeButtonId', '');
        this._removeButtonTitle = this._getConfigParam('removeButtonTitle', '');
    },

    _onInitDynamic() {
        $(this._addButtonId).replace(`<div id="${this._addButtonId}" class="text-value"></div>`);
        new SmallButton({
            id: `dynamicSubFormContentAddButton-${this._id}`,
            title: this._addButtonTitle,
            addCls: 'sb-item-add dynamicSubFormContentAddButton',
            handler: this.addContent.bind(this),
            disabled: this._isAddButtonDisabled(),
            renderTo: this._addButtonId,
        });
    },

    _isAddButtonDisabled() {
        return false;
    },

    _bindDynamicContent(content, isFirstElement) {
        if (!isFirstElement) {
            const wrapperId = this._initRemoveButtonWrapper(content);
            new SmallButton({
                id: wrapperId,
                title: this._removeButtonTitle,
                addCls: 'sb-item-remove dynamicSubFormContentRemoveButton',
                handler: this.deleteContent.bind(this, content),
                renderTo: wrapperId,
            });
        }
        return content;
    },

    _initRemoveButtonWrapper(content) {
        const wrapperId = `${this._removeButtonId}-${this._getRandomNumber()}`;
        content.select('.field-value input, .field-value select').last().insert({
            after: `<span id="${wrapperId}" class="${this._removeButtonId}"></span>`,
        });
        return wrapperId;
    },

    _prepareDynamicContent(content) {
        const newId = Math.floor(1000000 * Math.random());

        const nameRegExp = new RegExp(`(name=.*?\\[?${this._id}\\]?\\[)dynamicSubFormTemplate(\\])`, 'g');
        const idRegExp = new RegExp(`(id=.*?\\-?${this._id}-)dynamicSubFormTemplate(-)`, 'g');

        content = content.update(content.innerHTML
            .replace(nameRegExp, `\$1c${newId}\$2`)
            .replace(idRegExp, `\$1c${newId}\$2`)
        );

        return content;
    },

    _onUpdateDynamic() {
        const childs = this._componentElement.select('.dynamicSubFormContent');
        $$(`label[for="${this._addButtonId}"]`).first().toggle(!childs.length);
        if (childs.length) {
            childs.each(function (child, index) {
                child.select('label').last().toggle(!index);
            });
        }
    },

    addContent($super, event) {
        $super();
        Event.stop(event);
    },

    deleteContent($super, content, event) {
        $super(content);
        Event.stop(event);
    },
});



// WEBPACK FOOTER //
// ./jsw/dynamic-sub-form.js